import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../vendor/css/navbar.css";
import "boxicons/css/boxicons.min.css";
import { useCookies } from "react-cookie";

export default function Sidebar() {
  const [cookies, setCookie, removeCookie] = useCookies([
    "token",
    "user",
    "admin",
    "id",
  ]);
  const location = useLocation();

  const [openDropdowns, setOpenDropdowns] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);

  const getActiveLink = () => {
    const path = location.pathname;
    if (path === "/" || path === "/dashboard") return "Dashboard";
    if (path === "/users") return "Users";
    if (path === "/inquiryDetails") return "Inquiry Details";
    if (path === "/paymentDetails") return "Payment Details";
    if (
      [
        "/destination",
        "/hotels",
        "/prefferPartner",
        "/travelPartner",
        "/vacationBeingHere",
        "/clientTestimonial",
      ].includes(path)
    )
      return "Master";
    return "Dashboard";
  };

  useEffect(() => {
    const path = location.pathname;
    if (
      [
        "/destination",
        "/hotels",
        "/prefferPartner",
        "/travelPartner",
        "/vacationBeingHere",
        "/clientTestimonial",
      ].includes(path)
    ) {
      setOpenDropdowns({ Master: true });
    }
  }, [location]);

  const toggleDropdown = (menu) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  // ✅ Logout User
  const handleLogout = () => {
    removeCookie("token");
    removeCookie("user");
    removeCookie("admin");
    removeCookie("id");
    window.location.reload();
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`} id="navbar">
      <nav className="nav-container">
        <div>
          <div className="nav-header">
            <a href="/" className="nav-link nav-logo">
              <img
                src="/assets/images/AacoreHoliday-logo.png"
                alt="AACore Holiday Logo"
                width={isCollapsed ? 80 : 200}
                height={isCollapsed ? 80 : 200}
                style={{ objectFit: "contain" }}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentElement.innerHTML =
                    '<span style="color: white; font-weight: bold; font-size: 1.2rem;">AACore</span>';
                }}
              />
            </a>
          </div>

          <div className="nav-list">
            {!isCollapsed && (
              <span
                style={{
                  background:
                    "linear-gradient(90deg, #d400ff 0%, #00D9FF 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  fontWeight: "700",
                  fontSize: "1.4rem",
                  display: "block",
                  textAlign: "center",
                  marginBottom: "15px",
                  fontFamily: "'Playfair Display', 'Georgia', serif",
                  letterSpacing: "3px",
                }}
              >
                Aacore Holidays
              </span>
            )}
            <div className="nav-items">
              <a
                href="/"
                className={`nav-link ${
                  getActiveLink() === "Dashboard" ? "active" : ""
                }`}
              >
                <i className="bx bx-home nav-icon"></i>
                {!isCollapsed && <span className="nav-name">Dashboard</span>}
              </a>

              <a
                href="/users"
                className={`nav-link ${getActiveLink() === "Users" ? "active" : ""}`}
              >
                <i className="bx bx-user nav-icon"></i>
                {!isCollapsed && <span className="nav-name">Users</span>}
              </a>

              <a
                href="/inquiryDetails"
                className={`nav-link ${
                  getActiveLink() === "Inquiry Details" ? "active" : ""
                }`}
              >
                <i className="bx bx-message-rounded nav-icon"></i>
                {!isCollapsed && (
                  <span className="nav-name">Inquiry Details</span>
                )}
              </a>

              <a
                href="/paymentDetails"
                className={`nav-link ${
                  getActiveLink() === "Payment Details" ? "active" : ""
                }`}
              >
                <i className="bx bx-credit-card nav-icon"></i>
                {!isCollapsed && (
                  <span className="nav-name">Payment Details</span>
                )}
              </a>

              <div className="nav-dropdown">
                <a
                  href="#"
                  className={`nav-link ${
                    getActiveLink() === "Master" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("Master");
                  }}
                >
                  <i className="bx bx-cog nav-icon"></i>
                  {!isCollapsed && <span className="nav-name">Master</span>}
                  {!isCollapsed && (
                    <i
                      className={`bx bx-chevron-down nav-icon nav-dropdown-icon ${
                        openDropdowns["Master"] ? "rotated" : ""
                      }`}
                    ></i>
                  )}
                </a>

                {openDropdowns["Master"] && !isCollapsed && (
                  <div className="nav-dropdown-collapse">
                    <div className="nav-dropdown-content">
                      <a href="/destination" className="nav-dropdown-item">
                        Destination
                      </a>
                      <a href="/hotels" className="nav-dropdown-item">
                        Hotel
                      </a>
                      <a href="/prefferPartner" className="nav-dropdown-item">
                        Prefer Partner
                      </a>
                      <a href="/travelPartner" className="nav-dropdown-item">
                        Travel Partner
                      </a>
                      <a
                        href="/vacationBeingHere"
                        className="nav-dropdown-item"
                      >
                        Vacation Being Here
                      </a>
                      <a
                        href="/clientTestimonial"
                        className="nav-dropdown-item"
                      >
                        Client Testimonial
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <a href="#" className="nav-link nav-logout" onClick={handleLogout}>
          <i className="bx bx-log-out nav-icon"></i>
          {!isCollapsed && <span className="nav-name">Logout</span>}
        </a>
      </nav>
    </div>
  );
}
